import React, {useState} from "react"
import {categoriesContent} from "./categoryContent/categoriesContent"
import Typography from "../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import CatTabsWraper from "./CatTabsWraper"
import {ChevronDown, X} from "react-bootstrap-icons"
import BackgroundOverlay from "../reusable/components/BackgroundOverlay"
import AnimationComponent from "../reusable/components/AnimationComponent/AnimationComponent"

const ConsultationContent = () => {
	const {t} = useTranslation("consultationPage")
	const router = useRouter()
	const {tab} = router.query
	const catIdFromUrl = categoriesContent?.find(({slug, slugFr}) => tab === slug || tab === slugFr)?.id

	const [activeCat, setActiveCat] = useState<number>(catIdFromUrl || 1)
	const handleActiveChange = tabId => setActiveCat(tabId)

	const {content, title} = categoriesContent.filter(({id}) => id === activeCat)[0]
	const [isModalOpen, setIsModalOpen] = useState(false)

	return (
		<div className="pt-2">
			<div className="d-none d-md-flex mt-5 container justify-content-center justify-content-md-start col-12 container-lg">
				<Typography className="header-banner-title w-md-100 text-md-start"
					variant="heading1"
					semanticTag="h1">{"E-Bike Wiki"}</Typography>
			</div>
			<BackgroundOverlay zIndex={100000}
				isBackgroundOn={isModalOpen}/>
			<div className="container pt-4 pt-md-2 pb-4 mb-4">
				<div onClick={() => setIsModalOpen(true)}
					className="d-md-none rounded-2 py-2 ps-3  ms-0 d-flex justify-content-between"
					style={{border: "1px solid  #D2D7DC"}}>
					<span className="">
						<Typography variant="bodyLg"
							semanticTag="span">{t("choose topic")}:</Typography>
						<Typography className="ms-2"
							variant="bodyLgBold"
							semanticTag="span">{t(title)}</Typography>
					</span>
					<ChevronDown className="align-self-center me-3"/>
				</div>
			</div>
			<AnimationComponent inProp={isModalOpen}
				type="slideRight" >
				<div style={{zIndex: 1400000, borderRadius: 30}}
					className={"position-fixed bottom-0 left-0 d-flex align-items-center"}>
					<div className={"bg-white mx-auto d-flex"}
						style={{width: "100%", maxHeight: "80vh", overflow: "scroll", borderTopLeftRadius: "16px", borderTopRightRadius: "16px"}}>
						<div className="container">
							<div className="d-flex justify-content-end me-2 pb-2 pt-3">
								<X size={33}
									onClick={() => setIsModalOpen(false)}/>
							</div>
							<Typography variant="bodyLgBlack"
								className="mb-4">{t("Choose topic")}</Typography>
							<CatTabsWraper active={activeCat}
								setActive={handleActiveChange}
								tabsContent={categoriesContent}
								urlBase={"/bike-verzeichnis"}/>
						</div>
					</div></div>
			</AnimationComponent>
			<div className="container-lg d-none d-md-block mt-4 mb-5">
				<CatTabsWraper active={activeCat}
					setActive={handleActiveChange}
					tabsContent={categoriesContent}
					urlBase={"/bike-verzeichnis"}/>
				<hr/>
			</div>
			<div className="container-sm mb-5 pb-3 pb-md-5">
				{content}
			</div>
		</div>
	)
}

export default ConsultationContent
